"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var TOOLTIP_CODES = exports.TOOLTIP_CODES = {
    BREADCRUMB: 1
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/popupPanel/tooltips/tooltipConstants.js
// module id = 1929
// module chunks = 0